export const magCard = (state) => state.magSensor;
